import React, { useState } from "react"
import {
  Button,
  Col,
  FloatingLabel,
  Form,
  ProgressBar,
  Row,
  Spinner,
} from "react-bootstrap"
import * as Yup from "yup"
import ModalComponent from "../../../components/Modal"
import { toast } from "react-toastify"
import axiosProvider from "../../../lib/AxiosProvider"
import { admin } from "../../../config/apiEndpoints"
import { useFormik } from "formik"

const BulkUpload = ({ showBulkUpload, handleClose, fetchData }) => {
  const [loading, setLoading] = useState(false)
  const [isUpload, setIsUpload] = useState(false)

  const validationSchema = Yup.object({
    select_file: Yup.mixed()
      .required("File is required")
      .test(
        "fileType",
        "Only .xlsx files are allowed",
        (file) =>
          file &&
          file.type ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      )
      .test(
        "fileSize",
        "File size too large, max file size is 2 MB",
        (file) => file && file.size <= 2097152 // 2MB in bytes
      ),
  })

  const handleSubmit = async (values, { resetForm }) => {
    const { select_file } = values
    const formData = new FormData()
    formData.append("sheet", select_file)

    try {
      setLoading(true)
      const response = await axiosProvider({
        method: "POST",
        endpoint: admin.uploadBulkUploadFile,
        data: formData,
      })
      if (response?.data?.code === 200 || response?.data?.code === 201) {
        toast.success(response?.data?.message)
        setLoading(false)
        fetchData()
        resetForm()
        handleClose()
      } else {
        setLoading(false)
        throw { message: response?.data?.message }
      }
    } catch (error) {
      setLoading(false)
      toast.error(error?.message || "Error uploading the file")
    }
  }

  const formik = useFormik({
    initialValues: {
      select_file: null,
    },
    validationSchema,
    onSubmit: handleSubmit,
  })

  const { errors, touched, setFieldValue, resetForm, values } = formik

  const handleFileUpload = (event) => {
    const file = event.target.files[0]
    if (file) {
      setFieldValue("select_file", file)
    }
  }

  const handleDownloadTemplate = async () => {
    try {
      const response = await axiosProvider({
        method: "GET",
        endpoint: admin.downloadBulkUploadTemplate,
      })

      const url = process.env.REACT_APP_BASE_URL + response?.data?.data
      const link = document.createElement("a")
      link.href = url
      link.click()
      URL.revokeObjectURL(url)
    } catch (error) {
      toast.error("Error downloading the file")
    }
  }

  return (
    <>
      <ModalComponent
        show={showBulkUpload}
        modalsize={"md"}
        animationFade={true}
        backdrop="static"
        onHide={() => {
          handleClose()
          setIsUpload(false)
          resetForm()
        }}
        handleSubmit={formik.handleSubmit}
        loading={loading}
        modeltitle={"Bulk Upload"}
        submitname={
          loading ? (
            <Spinner size="sm" animation="border" variant="white" />
          ) : (
            isUpload && "Upload"
          )
        }
        btnclosetext={"Cancel"}
        children={
          <>
            {!isUpload && (
              <div className="d-flex gap-2 justify-content-evenly">
                <Button
                  variant="primary"
                  className="btn_icon align-items-center p-2 gap-2"
                  onClick={handleDownloadTemplate}
                  size="md"
                >
                  <i className="icon_main dowanload_file bg-white"></i> Download
                </Button>
                <Button
                  variant="warning"
                  className="btn_icon align-items-center p-2 gap-2"
                  size="md"
                  onClick={() => setIsUpload(true)}
                >
                  <i className="icon_main upload bg-dark"></i> Upload
                </Button>
              </div>
            )}
            {isUpload && (
              <Form noValidate onSubmit={formik.handleSubmit}>
                <Row xs={"auto"}>
                  <Col xs={12}>
                    <FloatingLabel
                      controlId="select_file"
                      label={
                        <>
                          Select file<span className="required_star">*</span>
                        </>
                      }
                    >
                      <Form.Control
                        type="file"
                        name="select_file"
                        onChange={handleFileUpload}
                        isInvalid={touched.select_file && errors.select_file}
                        isValid={touched.select_file && !errors.select_file}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.select_file}
                      </Form.Control.Feedback>
                    </FloatingLabel>
                  </Col>
                </Row>
              </Form>
            )}
            {/* {isUploading && (
              <ProgressBar
                now={uploadProgress}
                label={`${uploadProgress}%`}
                animated
                className="mt-2"
              />
            )} */}
          </>
        }
      />
    </>
  )
}

export default BulkUpload
